import { useEffect } from "react";
import { AuthNotice, AuthPage } from "../../auth/authKit";
import { useFocusHeading } from "./focusHeading";

/** Claves de texto de las dos vistas públicas del soporte delegado (Soporte/Denegado.razor y Soporte/Fin.razor). */
export const supportTextKeys = ["SUPPORT_DENIED_", "SUPPORT_ENDED_"];

/**
 * Vista de soporte sin sesión válida (/soporte/denegado): ticket vencido, usado o revocado. Pública a propósito: es el
 * destino del login vetado en el host de soporte y del canje fallido.
 */
export function SupportDeniedPage({ L }: { L: (key: string) => string }) {
  return <SupportNotice L={L} titleKey="SUPPORT_DENIED_TITLE" bodyKey="SUPPORT_DENIED_BODY" tone="error" />;
}

/** Cierre de la vista de soporte (/soporte/fin): la sesión normal del navegador nunca se tocó. */
export function SupportEndedPage({ L }: { L: (key: string) => string }) {
  return <SupportNotice L={L} titleKey="SUPPORT_ENDED_TITLE" bodyKey="SUPPORT_ENDED_BODY" tone="done" />;
}

function SupportNotice({
  L,
  titleKey,
  bodyKey,
  tone,
}: {
  L: (key: string) => string;
  titleKey: string;
  bodyKey: string;
  tone: "error" | "done";
}) {
  const title = L(titleKey);
  useEffect(() => {
    document.title = title;
  }, [title]);
  useFocusHeading(true);
  return (
    <AuthPage title={title}>
      <AuthNotice tone={tone}>{L(bodyKey)}</AuthNotice>
    </AuthPage>
  );
}
